import { ReactNode } from 'react';
import EmbeddedModeStatusBar from '../components/EmbeddedModeStatusBar';
import { useIsEmbeddedMode } from '../context/EmbeddedModeContext';

interface Props {
  children: ReactNode;
  isFeedbackOpen: boolean;
  widgetCloseInteraction: () => void;
  widgetHideInteraction: () => void;
}

const EmbeddedModeLayout = ({
  children,
  isFeedbackOpen,
  widgetCloseInteraction,
  widgetHideInteraction,
}: Props) => {
  const isEmbeddedMode = useIsEmbeddedMode();

  if (!isEmbeddedMode) {
    return <div className="h-screen">{children}</div>;
  }

  return (
    <div className="flex flex-col h-screen">
      <EmbeddedModeStatusBar
        isFeedbackOpen={isFeedbackOpen}
        widgetCloseInteraction={widgetCloseInteraction}
        widgetHideInteraction={widgetHideInteraction}
      />
      <div className="flex-1 overflow-auto min-h-0">{children}</div>
    </div>
  );
};

export default EmbeddedModeLayout;
